const theme = {
   primary: '#000000',
   secondary: '#39828E',
   accent: '#ffffff',
   backgroundColor: '#000000'
   };
  
  export default theme;